import type { Controller, Listeners } from './types';

class InitializerHelpers {
  public initControllers = (controllers: Controller[]): void => {
    controllers.forEach((controller) => controller.init?.());
  };

  public createListeners = (controllers: Controller[]): Listeners => {
    return {
      on: () => {
        controllers.forEach((controller) => controller.listeners.on());
      },
      off: () => {
        controllers.forEach((controller) => controller.listeners.off());
      },
    } as const;
  };
}

export const initializerHelpers = new InitializerHelpers();
